import React from "react";
import banner from '../Images/contact-banner.jpg';
import ContactForm from "../Components/ContactForm/ContactForm";
import ScrollReveal from "../Components/ScrollReveal/ScrollReveal";

const ContactUs = () => {
  return (
    <div className="overflow-x-hidden">
      <ScrollReveal variant="clip" distance={0}>
        <div className="w-[100vw] h-[100vh]">
          <img className="w-[100vw] h-[100vh] object-cover" alt="Contact Us Banner" src={banner}/>
          {/* Optional overlay */}
          <div className="overlay"></div>
        </div>
      </ScrollReveal>
      {/* <p className="text-center bg-[#fcfcfc] p-10">Contact Us</p> */}
      <ContactForm />
    </div>
  );
};

export default ContactUs;
